import axios from 'axios';

export function GetAuthority (key) {
  if (localStorage.getItem('pcs_time_stamp') > new Date().getTime()) {
    return localStorage.getItem(key);
  } else {
    RemoveAuthority();
    return false;
  }
}

export function SetAuthority (key, value) {
  localStorage.setItem('pcs_time_stamp', new Date().getTime() + 43195000);// 12小时
  return localStorage.setItem(key, value);
}

export function SetAnswer (key, value) {
  return localStorage.setItem(key, value);
}

export function RemoveAuthority () {
  localStorage.removeItem('pcs_time_stamp');
  localStorage.removeItem('pcs_user_token');
  localStorage.removeItem('pcs_user_id');
  localStorage.removeItem('pcs_user_name');
  localStorage.removeItem('pcs_true_name');
  localStorage.removeItem('pcs_org_name');
  localStorage.removeItem('pcs_org_id');
  localStorage.removeItem('pcs_org_abbr');
  localStorage.removeItem('pcs_login_success');
}

export function Logout () {
  const token = localStorage.getItem('pcs_user_token');
  if (!token) {
    console.warn('No token found, skipping logout request.');
    return Promise.resolve(); // 不报错，直接返回
  }

  return axios.delete('http://localhost:8001/pcs-auth/oauth/removeToken', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => {
      console.log('Logout successful:', response.data);
    })
    .catch(error => {
      console.error('Logout failed:', error.response.data || error.message);
      // 即使后端失败，也要清除本地状态
      RemoveAuthority();
    });
}



// WEBPACK FOOTER //
// ./src/authority.js